<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>

		<div class="co-order-summary-info">
			<h1 v-bind="ADAattr('h1')">Thank you for your order!</h1>

			<div>
				<p v-bind="ADAattr('focus')">
					You will receive an email within a few moments containing a confirmation for this order.
				</p>
				<p v-bind="ADAattr('focus')">
				  You will receive email notifications when physical items ship out and when digital materials are ready to access. Digital materials will be available to access in your bookstore account eLibrary.
				</p>
				<p v-bind="ADAattr('focus')" v-html="$globs['school_policy_tpl']" v-if="$globs['school_policy_tpl']"></p>
				<p v-if="inactivityInterval > 0" @mousemove="timeout = inactivityInterval" v-bind="ADAattr('focus')">
					<strong>For your security, you will be automatically logged out of your school account after <span class="co-text-highlight" v-bind="ADAattr('label', ADAtoUpperNearest(timeout))">{{ timeout }}</span> seconds of inactivity on this page.</strong>
				</p>
			</div>
		</div>

		<v-flex xs12 class="co-section" v-if="step === $const.STEP_RECEIPT">
			<div class="section-title">
				<h1 v-bind="ADAattr('h1')">
					Order Summary
				</h1>
			</div>

			<div class="co-receipt-body">
				<v-container grid-list-md v-for="(order, order_index) in orders" :key="order_index" class="co-receipt-order">
					<div v-bind="ADAattr('sr-only')">Order Number: {{ order.order_id }}</div>
					<div v-bind="ADAattr('hidden')">
						<v-layout wrap justify-space-between class="co-receipt-body-line">
							<v-flex xs12 md2>Order Number:</v-flex>
							<v-flex xs12 md10><strong>{{ order.order_id }}</strong></v-flex>
						</v-layout>
					</div>

					<template v-for="(address, address_index) in order.addresses">

						<v-layout wrap justify-space-between class="co-receipt-body-line co-receipt-body-line-books">
							<v-flex xs12 md2><span v-bind="ADAattr('hidden')">Delivery:</span></v-flex>
							<v-flex xs12 md10>
								<div class="co-products-sections">
									<div v-for="(section, s_index) in address.shipping_groups" :key="s_index" class="co-products co-products-brief">
										<div class="co-products-list-container">
											<ul class="co-products-list">
												<li v-for="(item, index) in section.items">
													<div class="copl-cover">
														<v-img
																:src="item.cover"
																height="100px"
																contain
																position="center center"
																v-bind="ADAattr('hidden')"
														></v-img>
													</div>
													<div class="copl-info">
														<h4 class="mb-2" v-bind="[
															ADAattr('focus'),
															ADAattr('label', ADAitemLabel(item.title, item.sku))
														]">
															{{ item.title }}
														</h4>
														<div v-bind="ADAattr('hidden')">{{ `ISBN: ${item.sku}` }}</div>
													</div>
												</li>
											</ul>
										</div>
										<div v-bind="ADAattr('sr-only')">Delivery:
											{{ customizeShippingLabel(section.shipping.type) }} for {{ section.shipping.cost ? '$' + formatPrice(section.shipping.cost) : 'Free' }},
											<span v-if="section.shipping.avg_delivery_date">
												with average estimated delivery on {{ ADAformatDate(section.shipping.avg_delivery_date) }},
											</span>
										</div>
										<div class="co-shipping-method-container co-shipping-method-container-selected" v-bind="ADAattr('hidden')">
											<div>{{ customizeShippingLabel(section.shipping.type) }} - <strong>{{ section.shipping.cost ? '$' + formatPrice(section.shipping.cost) :
												"Free"
												}}</strong>
												<div class="no-capitalize" v-if="section.shipping.free_shipping_forced">Congrats, you've unlocked Free Economy Shipping on your entire order!</div>
											</div>
											<div v-if="section.shipping.avg_delivery_date">Average Estimated Delivery: <strong>{{
												section.shipping.avg_delivery_date }}</strong></div>
										</div>

									</div>
								</div>
							</v-flex>
						</v-layout>

						<div v-bind="ADAattr('sr-only')">Shipping to: {{ formatAddressLabel(address.address) }}, address: {{ formatAddress(address.address, ' ', 'distinct') }}</div>
						<div v-bind="ADAattr('hidden')">
							<v-layout wrap justify-space-between class="co-receipt-body-line">
								<v-flex xs12 md2>Shipping To:</v-flex>
								<v-flex xs12 md10>
									<strong>{{ formatAddressLabel(address.address) }}</strong> {{ formatAddress(address.address, ' ', 'distinct') }}
								</v-flex>
							</v-layout>
						</div>

					</template>

					<div v-bind="ADAattr('sr-only')" v-if="order.payments.cc_payment || order.payments.gc_payment">
						Payment methods:
						<span v-if="order.payments.cc_payment">
							{{ order.payments.cc_payment.type || 'Payment' }}:
							${{ formatPrice(order.payments.cc_payment.amount) }},
						</span>
						<span v-if="order.payments.gc_payment" v-for="gcp in order.payments.gc_payment">
							{{ `${gcp.ending}: $${formatPrice(gcp.amount)}` }},
						</span>
					</div>
					<div v-bind="ADAattr('hidden')">
						<v-layout wrap justify-space-between class="co-receipt-body-line">
							<v-flex xs12 md2>Payment:</v-flex>

							<v-flex xs12 md10>
								<div v-if="order.payments.cc_payment">
									<strong>
										{{ `${order.payments.cc_payment.type || 'Payment'} ${order.payments.cc_payment.ending ? '*** ' +
										order.payments.cc_payment.ending : ''} - $${formatPrice(order.payments.cc_payment.amount)}` }}
									</strong>
								</div>

								<template v-for="gcp in order.payments.gc_payment" v-if="order.payments.gc_payment">
									<div xs10>
										<strong>
											{{ `${gcp.ending} ${gcp.code} - $${formatPrice(gcp.amount)}` }}
										</strong>
									</div>
								</template>
							</v-flex>

						</v-layout>
					</div>

				</v-container>
			</div>

		</v-flex>
		<v-flex id="rokt-placeholder" xs12 v-if="step === $const.STEP_RECEIPT">
		</v-flex>

		<v-flex xs12 class="co-ads" v-if="step === $const.STEP_RECEIPT && advertisement && advertisement.length > 0">
			<h2 class="co-ads-heading" v-bind="ADAattr('h2')">Special Offers for Students</h2>

			<div class="co-ads-block" v-for="ad in advertisement">

				<div v-if="ad.is_custom" v-html="ad.html"></div>
				<div v-else>
					<div v-bind:style="{ 'text-align': ad.interface_style }">
						<a
								:href="formatLink(ad.link)"
								:data-gaaction="ad.type"
								:data-galabel="ad.text"
						>
							<img
									v-if="ad.image"
									:src="ad.image"
									:data-rjs="ad.image_for_retina ? ad.image_for_retina : null"
									:title="ad.html"
									onload="processGAAction(event);"
									v-bind="ADAattr('img', ad.text)"
							/>

							<img
									v-else
									src="https://www.textbookx.com/img/email/empty.gif"
									onload="processGAAction(event);"
									v-bind="ADAattr('img', ad.text)"
							/>
						</a>

					</div>
				</div>
			</div>
		</v-flex>

		<v-container grid-list-md class="co-receipt-recommended" v-if="sections_recommended.length > 0 || sections_recommended_loading">
			<v-layout row wrap>
				<v-flex xs12>
					<required-books-block
							:items="sections_recommended"
							:title="recommendations.title"
							:limit="section_limit"
							:loading="sections_recommended_loading"
							@load-more="loadMoreRecommended"
					></required-books-block>
				</v-flex>
			</v-layout>
		</v-container>

		<div class="co-receipt-cj">
			<template v-for="url in cj">
				<iframe height='1' width='1' frameborder='0' scrolling='no' name='cj_conversion' :src="url" v-bind="ADAattr('iframe', 'Receipt details')"></iframe>
			</template>
		</div>

	</div>
</template>

<script>
	import {formatAddressLabel, formatAddress, formatPrice} from './../includes/Miscellaneous';
	import {customizeShippingLabel} from './../includes/SpecialCasesHandles';
	import RequiredBooksBlock from "./../../common/components/vuejs/RequiredBooksBlock";
	import Axios from 'axios';

	export default {
		name: "Receipt",

		components: {
			RequiredBooksBlock,
		},

		props: {
			step: {
				type: Number,
			},

			orders: {
				type: Array,
			},

			payments: {
				type: Object,
			},

			items: {
				type: Array,
			},

			advertisement: {
				type: Array,
			},

			cj: {
				type: Array,
				default: [],
			},

			inactivityInterval: {
				type: Number,
				default: 0,
			},
		},

		data() {
			return {
				section_limit: 5,
				timeout: 0,
				timeout_interval: null,

				recommendations: {
					title: 'Other materials for your courses',
					title_has_required: 'Other materials for your courses',
					title_recommended_only: 'You may also like',
					sections: [],
				},

				featured: {
					title: 'School supplies',
					section: {},
				},

				sections_recommended_loading: false,
			};
		},

		mounted() {
			if (typeof sendFBPixelAction === 'function') {
				_.forEach(this.orders, order => {
					sendFBPixelAction('Purchase', {
						value: order.grand_total,
						currency: 'USD',
						order_id: order.order_id,
						content_type: 'product',
					});
				});
			}

			if (typeof sendGAAction === 'function') {
				sendGAAction('Receipt page: page loaded');
			}

			this.fetchRecommendations();
			this.updateInactivityInterval(this.inactivityInterval);
		},

		watch: {
			inactivityInterval(value) {
				this.updateInactivityInterval(value);
			},
		},

		methods: {
			formatAddressLabel,
			formatAddress,
			formatPrice,
			customizeShippingLabel,

			formatLink(link) {
				if (!link || !_.isString(link) || !link.length) return '';

				if (_.startsWith(link, '/')) {
					const dom = this.$globs['is_inst'] ? this.$globs['true_domain'] : 'www';
					return `//${dom}.textbookx.com${link}`;
				}

				return link;
			},

			updateInactivityInterval(value) {
				const self = this;

				if (self.timeout_interval) {
					window.clearInterval(self.timeout_interval);
				}

				if (!value) {
					return;
				}

				self.timeout = value;

				self.timeout_interval = window.setInterval(() => {
					self.timeout--;

					if (self.timeout <= 0) {
						window.clearInterval(self.timeout_interval);
						document.location.href = '/account/logout.php';
						return;
					}
				}, 1000);
			},

			fetchRecommendations() {
				const self = this;

				if (self.$globs['required_books_enabled']) {
					self.sections_recommended_loading = true;

					if (typeof sendGAAction === 'function') {
						sendGAAction('Receipt page: loading required books block');
					}

					Axios.get(`/tools/ajax/misc_ajax.php/requiredBooks?json=true&referrer=receipt&limit=${self.section_limit}`).then(({data}) => {

						if (data.recommendations.recommended.books.length > 0) {
							if (typeof sendGAAction === 'function') {
								sendGAAction('Receipt page: recommended books successfully loaded');
							}
						}
						if (data.recommendations.required.books.length > 0) {
							if (typeof sendGAAction === 'function') {
								sendGAAction('Receipt page: required books successfully loaded');
							}
						}
						if (data.recommendations.required.books.length === 0 && data.recommendations.recommended.books.length === 0) {
							if (typeof sendGAAction === 'function') {
								sendGAAction('Receipt page: required books list empty');
							}
						}

						self.recommendations.sections = data.recommendations;
						self.sections_recommended_loading = false;
					});
				}
			},

			loadMoreRecommended(offset) {
				if (!this.$globs.required_books_enabled) {
					return;
				}

				const limit = offset < 0 ? this.section_limit * 10 : this.section_limit + offset;
				this.sections_recommended_loading = true;

				Axios.get('/tools/ajax/misc_ajax.php/requiredBooks?json=true&referrer=receipt&limit=' +
					limit
				).then(({data}) => {
					let books = [];
					_.each(data.recommendations, group => {
						books = _.concat(books, group.books);
					});
					if (offset >= books.length) {
						offset %= books.length;
					}
					books = _.slice(_.slice(books, offset), 0, this.section_limit);
					if (books.length) {
						_.each(data.recommendations, group => {
							group.books = _.filter(group.books, book => _.includes(books, book));
						});
						this.recommendations.sections = data.recommendations;
					}
				}).finally(() => {
					this.sections_recommended_loading = false;
				});
			},
		},

		computed: {
			sections_recommended() {
				const items = [];
				_.forEach(this.recommendations.sections, sec => {
					_.forEach(sec['books'], book => {
						book.type = sec['type'];
						book.ga_action = sec.ga_action;
						items.push(book);
					});
				});

				if (_.get(this.recommendations.sections, 'required.books', []).length) {
					this.recommendations.title = this.recommendations.title_has_required;
				} else {
					this.recommendations.title = this.recommendations.title_recommended_only;
				}

				return items;
			},

			sections_featured() {
				const items = [],
					ga_action = this.featured.section.ga_action;
				_.forEach(this.featured.section['books'], book => {
					book.type = 'featured';
					book.ga_action = ga_action;
					items.push(book);
				});

				return items;
			},
		},
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #2170f2;

	.co-order-summary-info {
		h1 {
			margin-bottom: 20px;
		}

		> div {
			margin-bottom: 30px;
			font-size: 16px;
		}
	}

	.co-receipt-body {
		font-size: 15px;

		.co-receipt-order {

			.co-receipt-body-line {
				margin-top: 20px;

				&.co-receipt-body-line-books ~ .co-receipt-body-line-books {
					border-top: 1px solid #E0E0E0 !important;
				}

				&:first-child {
					border-top: 1px solid #E0E0E0;
					margin-top: auto;
				}

				@media screen and (max-width: 600px) {
					flex-direction: column;
					padding-bottom: 10px;
				}
			}

			&:first-child {
				.co-receipt-body-line {
					border-top: none;
				}
			}
		}
	}

	.co-products-sections {
		.co-products {
			overflow: hidden;
			border-top: 1px solid #E0E0E0;

			&:first-child {
				border-top: none;
			}

			.co-products-list-container {
				flex: 2;
				margin-right: 5%;

				ul.co-products-list {
					list-style: none;
					padding-left: 0;

					> li {
						overflow: hidden;
						padding: 10px 0;
						display: flex;
						align-items: flex-start;

						border-top: 1px solid #E0E0E0;

						&:first-child {
							border-top: none;
						}

						h3 {
							color: #767676;
							font-size: 16px;
							font-weight: normal;
							margin-bottom: 10px;
							text-transform: uppercase;
						}

						.copl-cover {
							display: block;
							flex: 1;
						}

						.copl-info {
							display: block;
							box-sizing: border-box;
							flex: 4;
							padding: 10px;

							div {
								font-size: 14px;
							}
						}
					}
				}
			}

			&.co-products-brief {
				display: flex;
				align-items: flex-start;

				@media screen and (max-width: 600px) {
					flex-direction: column;
				}
			}
		}

		/deep/ .co-shipping-method-container {
			font-size: 15px;
			flex: 1;
			text-transform: capitalize;
			text-align: right;
			padding: 20px 10px 0;

			@media screen and (max-width: 600px) {
				padding: 0;
			}

			.co-select-shipping {
				.v-label {
					font-size: 15px;
				}
			}

			&.co-shipping-method-container-selected {
				box-sizing: border-box;
				text-transform: capitalize;

			   .no-capitalize {
				text-transform: none;
			  }
			}

			.co-sm-header {
				font-size: 15px;
				font-weight: bold;

				strong {
					color: @text_highlight_color;
				}
			}

			.co-estimated-delivery-container {
				width: 80%;
				border: 1px solid #E0E0E0;
				padding: 10px;
				margin-bottom: 20px;
			}
		}
	}

	.co-receipt-recommended {
		padding: 24px 0;
	}

	.co-ads {
		padding: 24px 0 !important;

		.co-ads-heading {
			color: #000 !important;
			padding: 10px 0 20px !important;
			font-size: 18px !important;
		}
	}

	.co-receipt-cj {
		position: absolute;
		width: 1px;
		height: 1px;
		top: -99999px;
		left: -99999px;
	}

	.co-ads-block {
		img {
			max-width: 100%;
		}
	}
</style>
